<template>
    <div class="row search-world-input">
        <div class="d-flex align-items-center w-100">
            <div class="form-group flex-fill">
                <div class="d-flex input-group">
                    <div class="form-control pl-2 gen-search">
                        <input type="text" v-model="search_string" :placeholder="sportPlaceholder" class="border-none form-control inner-form">
                    </div>

                    <div class="form-control input-pos-container">
                        <gmap-autocomplete
                            placeholder="Ovunque"
                            @place_changed="setPlace"
                            @focus.native="onFocus(false)"
                            @input.native="changeAddress"
                            @blur.native="onBlur"
                            ref="mypos"
                            class="form-control border-none inner-form"
                            v-model="municipality.name"
                        >
                        </gmap-autocomplete>
                        <div class="mypos-container mypos-logo" v-if="inputType === false">
                            <div class="mypos-item" @click="setMyPosition">
                                <span class="mypos-icon mypos-icon-marker"></span>
                                <span class="mypos-item-query">La mia posizione</span>
                            </div>
                        </div>
                    </div>

                    <div class="input-group-append">
                        <button type="button"
                            @click="sendGA"
                            class="btn btn-primary-gradient text-white text-uppercase navbar-search-button fw-600">
                            Cerca <img src="/images/icons/complete-arrow-right-icon.svg" class="d-none d-md-inline-block" alt="Pulsante Cerca">
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div id="search-companies__container" class="search-companies__container d-none d-md-block">
            <h1 class="text-white font-24 line-height-30 font-weight-bold">Cerchi una struttura sportiva?</h1>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <i class="fa fa-search"></i>
                </div>
                <input type="text" class="pl-2 form-control"
                    v-model="search_company"
                    @focus="onSearchCompanies" @input="onSearchCompanies"
                    placeholder="Inserisci nome">
            </div>

            <transition
                name="fade"
                enter-active-class="animated fadeIn"
                leave-active-class="animated fadeOut"
            >
                <div class="list-group" v-if="companies.length > 0">
                    <div v-for="company in companies" class="list-group-item">
                        <div @click="onShowCompanyPage(company)" class="clickable list-group-item__icon-company">
                            <p class="font-14 fw-500 line-height-18 mb-0" v-text="company.public_name"></p>
                            <span
                                class="d-block text-uppercase font-12 line-height-16"
                                v-text="company.address"
                            ></span>
                        </div>
                    </div>
                </div>
            </transition>
        </div>

        <div class="w-100 d-flex align-items-center justify-content-center d-md-none">
            <button type="button" data-toggle="modal" data-target="#searchCompanyFormModal" class="mt-3 font-14 fw-500 line-height-18 btn btn-outline-search">
              Cerchi una struttura sportiva?
            </button>
        </div>
    </div>
</template>

<style>
.search-where-field-container { padding-left: 1px !important; padding-right: 1px !important; }
.search-where-field-container .img-abs { position: absolute; left: 5px; }
.search-where-field-container input {
    width: 100%;
    border: none;
    padding-left: 30px;
}

.mypos-container {
    background-color: #fff;
    position: absolute!important;
    top: 37px;
    left: 1px;
    z-index: 1000;
    width: 100% ;
    border-radius: 2px;
    border-top: 1px solid #d9d9d9;
    font-family: Arial,sans-serif;
    box-shadow: 0 2px 6px rgba(0,0,0,0.3);
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow: hidden;
}

.mypos-container.mypos-logo {
    z-index: 99999999;
}

.mypos-item {
    cursor: default;
    padding: 0 4px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-height: 30px;
    text-align: left;
    border-top: 1px solid #e6e6e6;
    font-size: 11px;
    color: #999;
}

.mypos-icon-marker {
    background-position: -1px -161px;
}

.mypos-icon {
    width: 15px;
    height: 20px;
    margin-right: 7px;
    margin-top: 6px;
    display: inline-block;
    vertical-align: top;
    background-image: url(https://maps.gstatic.com/mapfiles/api-3/images/autocomplete-icons.png);
    background-size: 34px;
}

.mypos-item-query {
    font-size: 13px;
    padding-right: 3px;
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: -0.3px;
    color: rgba(74, 74, 74, 0.9);
}
</style>

<script>

    export default {
        name: 'HomeSearchbar',
        props: {
            url: String,
            sportPlaceholder: String,
            cityPlaceholder: String
        },
        data() {
            return {
                dropdownOpen: false,
                city: null,
                municipality: {
                    name: null
                },
                search_string: null,
                municipalities: [],
                coords: [],
                inputType: true,
                requiredWhere: false,
                companies: [],
                search_company: null
            }
        },
        mounted() {
            this.getLocation();

            this.municipality = {name: null}

            window.addEventListener('click', (e) => {
                if (! document.getElementById('search-companies__container').contains(e.target)) {
                    this.$set(this, 'companies', [])
                }
            })

            $('.navbar-toggler').on('click', function () {
                vm.dropdownOpen = false
            })

            $(".search-world-input").keyup(function (event) {
                event.preventDefault();
                if (event.keyCode == 13) {
                    $(".search-world-button").click();
                }
            });

            $("#searchCompanyFormModal").on('shown.bs.modal', () => {
                this.dropdownOpen = false
            })
        },
        methods: {
            onClickDropdown() {
                this.dropdownOpen = !this.dropdownOpen
            },
            onShowCompanyPage(company) {
                this.$set(this, 'search_company', null)
                location.href = route('company.show', company.slug)
            },
            onSearchCompanies(e) {
                if (!_.isEmpty(e.target.value)) {
                    this.searchCompanies(this, e.target.value)
                }
            },
            searchCompanies: _.debounce((vm, term) => {
                let url = route('companies.search')

                axios
                    .get(`${url}?term=${window.encodeURIComponent(term)}`)
                    .then(response => {
                        vm.$set(vm, 'companies', response.data.companies)
                    })
            }, 500),
            getSearchUrl() {
                if (this.coords.length != 0) {
                    return this.url +
                        '?search_string=' +
                        (this.search_string != null ? this.search_string : '') +
                        '&municipality=' +
                        (this.municipality != null ? this.municipality.name : "") +
                        '&latitude=' +
                        this.coords[0] +
                        '&longitude=' +
                        this.coords[1] +
                        '&city=' +
                        this.city
                } else {
                    return this.url +
                        '?search_string=' +
                        (this.search_string != null ? this.search_string : '') +
                        '&municipality=' +
                        (this.municipality != null ? this.municipality.name : "") +
                        '&latitude=' +
                        null +
                        '&longitude=' +
                        null +
                        '&city=' +
                        null
                }
            },
            getLocation() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(this.returnPosition, this.errorPosition);
                }
            },
            returnPosition(position) {
                if(this.coords.length === 0) {
                    this.coords = [];

                    this.coords.push(position.coords.latitude);
                    this.coords.push(position.coords.longitude);
                    this.$bus.$emit('geolocalizated', {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                    });
                }

                this.requiredWhere = false;
            },
            errorPosition(error) {
                this.requiredWhere = true;
                this.$bus.$emit('geoerror');
                console.log(error);
            },
            sendGA() {
                if(this.coords.length === 0 && this.requiredWhere === true) {
                    alert('Attenzione: Occorre selezionare un luogo, per poter effettuare la ricerca!')
                    return false
                }

                if(_.isEmpty(this.municipality.name) || _.isEmpty(this.$refs.mypos.$refs.input.value)) {
                    this.$refs.mypos.$refs.input.value = 'La mia posizione'
                    this.municipality.name = 'La mia posizione'
                }

                if(this.coords.length > 0 || this.requiredWhere == false) {
                    // ga('send', 'event', 'Ricerca', 'RicercaCorso', 'HomePage');
                    window.location = this.getSearchUrl();
                }

            },
            setPlace(place) {
                if (place) {
                    this.coords = [];
                    this.coords.push(place.geometry.location.lat());
                    this.coords.push(place.geometry.location.lng());

                    let city = _.head(place.address_components.filter(i => i.types.includes('locality')))
                    if (!_.isEmpty(city)) {
                        this.city = city.long_name
                    }
                    this.municipality = { name: place.formatted_address }
                }
            },
            onFocus(action) {
                if(this.requiredWhere == false)
                this.inputType = false
            },
            onBlur() {
                setTimeout(() => this.inputType = true, 200);
            },
            changeAddress() {
                if(this.$refs.mypos.$refs.input.value !== '')
                    this.inputType = true
                else if(this.requiredWhere == false) {
                    this.inputType = false
                    this.coords = []
                    this.getLocation()
                } else
                    this.coords = []
            },
            setMyPosition() {
                this.coords = []
                this.getLocation()
                this.$refs.mypos.$refs.input.value = 'La mia posizione'
                this.municipality.name = 'La mia posizione'
                this.inputType = true
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/search/HomeSearchbar.vue